import React, { Component } from 'react';
import { Form, FormGroup, Input, Label, Button } from 'reactstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Upload from '../common/Upload/Upload';
import cn from 'classnames';

const defaultStateData = {
  text: '',
  'uploads[]': [],
};

export class ReplyTicketForm extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    data: defaultStateData,
    loading: false,
    errors: {},
  };

  textareaRef = React.createRef();

  onChange = (e) => {
    const { target } = e;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      },
    }));

    this.autoResizeTextarea();
  };

  autoResizeTextarea = () => {
    const textarea = this.textareaRef.current;
    if (textarea) {
      textarea.style.height = '36px';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  onFilesChange = (file) => {
    this.setState((prevState) => {
      return {
        data: {
          ...prevState.data,
          'uploads[]': [...prevState.data['uploads[]'], file],
        },
      };
    });
  };

  onDeleteFile = (deleteIndex) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        data: {
          ...prevState.data,
          'uploads[]': prevState.data['uploads[]'].filter((item, index) => index !== deleteIndex),
        },
      };
    });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate(this.state.data);
    this.setState({ errors });

    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });

      this.props.submit(this.state.data).then((errorMessage) => {
        if (!errorMessage) {
          this.setState(
            (prevState) => ({
              ...prevState,
              data: defaultStateData,
            }),
            () => {
              this.autoResizeTextarea();
            },
          );
        } else {
          this.setState((prevState) => ({
            ...prevState,
            data: {
              ...prevState.data,
              'uploads[]': [],
            },
          }));
        }
      });
    }
  };

  validate = (data) => {
    const errors = {};

    if (!data.text) {
      errors.text = this.props.intl.formatMessage({
        id: 'tickets.field.required',
        defaultMessage: 'This field is required',
      });
    }

    return errors;
  };

  componentDidMount() {
    this.autoResizeTextarea();
  }

  render() {
    const { text } = this.state.data;
    const { errors, loading } = this.state;
    const { intl } = this.props;

    return (
      <Form onSubmit={this.onSubmit} method="POST" autoComplete="off" className="reply-ticket-form">
        <FormGroup
          className={cn('reply-ticket-form-group', {
            'has-error': errors.text,
          })}
        >
          <Upload
            type="file"
            onChange={this.onFilesChange}
            loading={loading}
            onDelete={this.onDeleteFile}
          />
          <div className="reply-ticket-form-bottom">
            <Input
              id="ticket_text"
              type="textarea"
              name="text"
              value={text}
              innerRef={this.textareaRef}
              placeholder={
                intl.formatMessage({ id: 'tickets.msg.text', defaultMessage: 'Message text' }) +
                '...'
              }
              onChange={this.onChange}
              required
            />
            {errors.text && <small className="form-text">{errors.text}</small>}
            <Button className="reply-ticket-form-btn" color="primary" disabled={!text}>
              <FormattedMessage id="tickets.send" defaultMessage="Send" />
            </Button>
          </div>
        </FormGroup>
      </Form>
    );
  }
}

export default injectIntl(ReplyTicketForm);
